import DashboardDispatcher from "../dispatcher/DashboardDispatcher";
import DashboardConstants from "../constants/DashboardConstants";
import { format, parseISO } from "date-fns";

var objectAssign = require("object-assign");
var EventEmitter = require("events").EventEmitter.prototype;

var DashboardStore = objectAssign({}, EventEmitter, {
  _state: {
    initialized: false,
    daily_rentals: false,
    activeTab:
      new URLSearchParams(window.location.search).get("view_mode") || "nightly",
    currentDate: new Date(),
    dateData: {},
    dateFormat: null,
    loading: false,
    readOnly: false,
    timeFormat: null,
    reservationSegments: [],
    reservationsUserRole: null,
    roomTypes: [],
    settingsUserRole: null,
  },

  /**
   * Event Listener, Event Emitter
   */

  emitChange: function () {
    this.emit(DashboardConstants.CHANGE_EVENT);
    this._state.forceUpdate = false;
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(DashboardConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(DashboardConstants.CHANGE_EVENT, callback);
  },

  /*
   * Initializes the store
   *
   * @param {object} opts
   */
  init: function (opts) {
    objectAssign(this._state, opts);

    if (opts.currentDate) {
      this._state.currentDate = parseISO(opts.currentDate);
    }

    // rehydrate activeTab
    const activeTabParam = new URLSearchParams(window.location.search).get("view_mode");
    if (activeTabParam) {
      localStorage.setItem('Dashboard|activeTab', activeTabParam);
    }
    
    const activeTabCookie = localStorage.getItem('Dashboard|activeTab');
    if (activeTabParam) {
      this._state.activeTab = activeTabParam;
    } else if (activeTabCookie) {
      this._state.activeTab = activeTabCookie;
    }

    this._state.initialized = true;
    this.refreshData();
  },

  expandCollapseRoomType: function (roomType, collapsed) {
    for (var i = 0, ilen = this._state.roomTypes.length; i < ilen; i++) {
      if (this._state.roomTypes[i].id == roomType.id) {
        this._state.roomTypes[i].collapsed = collapsed;
        break;
      }
    }
  },

  /*
   * Simple getters
   */

  getActiveTab: function () {
    return this._state.activeTab;
  },

  getCurrentDate: function () {
    return this._state.currentDate;
  },

  getDateData: function () {
    return this._state.dateData;
  },

  getDateFormat: function () {
    return this._state.dateFormat;
  },

  getLoading: function () {
    return this._state.loading;
  },

  getReadOnly: function () {
    return this._state.readOnly;
  },

  getRoomTypes: function () {
    return this._state.roomTypes;
  },

  getReservationSegments: function () {
    return this._state.reservationSegments;
  },

  getReservationsUserRole: function () {
    return this._state.reservationsUserRole;
  },

  getSettingsUserRole: function () {
    return this._state.settingsUserRole;
  },

  getTimeFormat: function () {
    return this._state.timeFormat;
  },

  /*
   * Go to the given date (loading reservations)
   */
  gotoDate: function (date) {
    // console.log("gotoDate this._state", this._state);

    
    var self = this;

    if (typeof date === "number") {
      date = new Date(date);
    }

    if (history.pushState) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?date=" +
        format(date, "yyyy-MM-dd") +
        "&view_mode=" +
        self._state.activeTab;
      window.history.pushState({ path: newurl }, "", newurl);
    }

    self._state.currentDate = date;
    self._state.loading = true;
    self.emitChange();

    // load data from server
    $.ajax({
      type: "POST",
      url: self._state.property_calendar_reservation_segments_path,
      data: {
        current_date: self._state.currentDate,
        view_mode: self._state.activeTab,
        daily_rentals: self._state.daily_rentals
      },
    }).done(function (data) {
      if (data.reservation_segments && data.reservation_segments.length) {
        self._state.reservationSegments = data.reservation_segments;
      } else {
        self._state.reservationSegments = [];
      }

      if (data.room_types && data.room_types.length) {
        self._state.roomTypes = data.room_types;
      } else {
        self._state.roomTypes = [];
      }

      if (data.date_data) {
        self._state.dateData = data.date_data;
      } else {
        self._state.dateData = {};
      }
      self._state.loading = false;
      self.emitChange();
    });
  },

  refreshData: function () {
    this.gotoDate(new Date(this._state.currentDate) || new Date());
  },
});

DashboardStore.dispatchToken = DashboardDispatcher.register(function (payload) {
  switch (payload.action) {
    case DashboardConstants.INIT:
      DashboardStore.init(payload.opts);
      DashboardStore.emitChange();
      break;

    case DashboardConstants.GOTO_DATE:
      DashboardStore.gotoDate(payload.date);
      break;

    case DashboardConstants.REFRESH_DATA:
      DashboardStore.refreshData();
      break;

    case DashboardConstants.SET_ACTIVE_TAB:
      DashboardStore._state.activeTab = payload.activeTab;
      localStorage.setItem('Dashboard|activeTab', payload.activeTab);
      DashboardStore.refreshData();
      break;

    case DashboardConstants.EXPAND_COLLAPSE_ROOM_TYPE:
      DashboardStore.expandCollapseRoomType(
        payload.roomType,
        payload.collapsed
      );
      DashboardStore.emitChange();
      break;

    default:
    // no op
  }
});

/* silence the EventEmitter */
DashboardStore.setMaxListeners(0);

$(window).on("refresh_data_table", function () {
  if (DashboardStore._state.initialized) {
    DashboardStore.refreshData();
  }
});

export default DashboardStore;
